import { Types } from "../actions/SnackbarActions";

const initialState = {
    successSnackbarMessage: "",
    successSnackbarOpen: false,
    errorSnackbarMessage: "",
    errorSnackbarOpen: false,
    infoSnackbarMessage: "",
    infoSnackbarOpen: false,
};

export const SnackbarReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SNACKBAR_SUCCESS:
            return {
                ...state,
                successSnackbarOpen: true,
                successSnackbarMessage: action.message,
            };
        case Types.SNACKBAR_ERROR:
            return {
                ...state,
                errorSnackbarOpen: true,
                errorSnackbarMessage: action.message,
            };
        case Types.SNACKBAR_INFO:
            return {
                ...state,
                infoSnackbarOpen: true,
                infoSnackbarMessage: action.message,
            };
        case Types.SNACKBAR_CLEAR:
            return {
                ...state,
                successSnackbarMessage: "",
                successSnackbarOpen: false,
                errorSnackbarMessage: "",
                errorSnackbarOpen: false,
                infoSnackbarMessage: "",
                infoSnackbarOpen: false,
            };
        default:
            return state;
    }
};
